import { $GET, $POST } from '../libs/http'

/**
 * @desc 向邮箱发送验证码
 * @param {String} mail - 邮箱地址
 * @param {Object} opts - 配置信息
 * @return {Promise}
 */
export function sendEmailVerifyCode(mail, opts) {
    return $POST('/api/v1/minicash/fetchMailVerifyCode', { workEmail: mail }, opts)
}

/**
 * @desc 向邮箱发送验证码
 * @param {String} mail - 邮箱地址
 * @param {Object} opts - 配置信息
 * @return {Promise}
 */
export function sendEmailVerifyCodeNew(mail, opts) {
    return $POST('/api/v1/minicash/sendemailverifycode', { workEmail: mail }, opts)
}

/**
 * @desc 预注册
 * @param {Object} body - bizType (check/preRegister), mobile 手机号, regChannel 渠道, verifyCode 手机验证码, promotionChannel 推广渠道
 * @param {Object} opts
 */
export function preRegist(body, opts) {
    return $POST('/api/v1/preRegister', body, opts)
}

/**
 * @desc 发送手机验证码
 * @param {Object} body - bizType (check/preRegister), mobile 手机号, regChannel 渠道, verifyCode 手机验证码, promotionChannel 推广渠道
 * @param {Object} opts
 */
export function sendCode(body, opts) {
    return $POST('/api/v1/verifycode', body, opts)
}

/**
 * @desc 发送手机验证码
 * @param {String} body {mobile,scenario:pre_register,captcha:图形验证码}
 * @param {Object} opts 参数
 * @returns {Promise}
 */
export function sendMobileVerifyCodeV2(body, opts) {
    return $POST('/api/v2/verifycode', body, opts)
}

/**
 * @desc 获取微信URL Scheme
 * @param {String} body {channel,requestType:shd_xcx}
 * @param {Object} opts 参数
 * @returns {Promise}
 */
export function getShortLink(body, opts) {
    return $POST('/api/v1/sr/get/short/link', body, opts)
}

/**
 * @desc 发送手机验证码
 * @param {String} body 手机号 {mobile,scenario:extra_info/add_bankcard}
 * @param {Object} opts 参数
 * @returns {Promise}
 */
export function sendUserMobileVerifyCodeV2(body, opts) {
    return $POST('/api/v2/user/verifycode', body, opts)
}

/**
 * @desc 获取图形验证码
 * @param {*} body {mobile,bizType:preRegisterCaptcha}
 * @param {*} opts
 */
export function refreshCaptcha(body, opts) {
    return $POST('/api/v1/refreshcaptcha', body, opts)
}

/**
 *
 */
export function fetchUserInfo(params, opts) {
    return $GET('/api/v1/user/myinfo', params, opts)
}

/**
 *
 */
export function generateBarcode(params, opts) {
    return $GET('/api/v1/generateBarcode', params, opts)
}

/**
 * @desc 查询用户额度
 * @param {Object} params
 * @param {Object} opts
 */
export function fetchQuota(params, opts) {
    return $GET('/api/v1/minicash/user/welcome', params, opts)
}

/**
 *
 * @param {*} vue
 * @param {*} opts
 */
export function checkLogin(vue, opts) {
    return vue.http.get ('/timesloan/api/v1/user/myinfo', opts)
}

/**
 *
 * @param {*} vue
 * @param {*} opts
 */
export function refreshAppconfig(body, opts) {
    return $GET('/appconfig', body, opts)
}

/**
 *
 *
 * @param {*} vue
 * @param {*} opts
 */
export function homeproductsrate(body, opts) {
    return $GET('/v3/homeproductsrate', body, opts)
}

// app最新版本号
export function getLatestVersion(body, opts) {
    return $GET('/api/v1/app/latestVersion', body, opts)
}

// PE体育提交页面
export function questionnaireSave(body, opts) {
    return $POST('/api/v1/sports/questionnaire/save', body, opts)
}

/**
 * @desc 对接光大银行获取手机号
 * @param {Object} body - code 授权码
 * @param {Object} opts
 */
export function queryMobile(body, opts) {
    return $GET('/api/v1/everbrightBank/queryMobile', body, opts)
}

/**
 * @desc 万达钱包红包进度条接口
 * @param {Object} body
 * @param {Object} opts
 */
export function memberRedPacket(body, opts) {
    return $POST('/api/v1/red/proportion', body, opts)
}

/**
 *
 * @param {*} vue
 * @param {*} opts
 */
export function walletLink(body, opts) {
    return $POST('/api/v1/wallet/link', body, opts)
}

/**
 *
 * @param {*} vue
 * @param {*} opts
 */
export function wddLink(body, opts) {
    return $POST('/api/v1/sr/get/short/link', body, opts)
}

/**
 * @desc 商户代运营-用户登录
 * @param {Object} body
 * @param {Object} opts
 */
 export function threeUserLogin(body, opts) {
    return $POST('/three/loan/user/login', body, opts)
}

/**
 * @desc 三贷用户信息查询
 * @param {Object} body
 * @param {Object} opts
 */
 export function threeUserInfo(body, opts) {
    return $POST('/three/loan/user/info/query', body, opts)
}

/**
 * @desc 会员权益入口
 * @param {Object} body
 * @param {Object} opts
 */
export function menuUrl(body, opts) {
    return $POST('/api/v1/menu/url', body, opts)
}

/**
 * @desc 列表
 * @param {Object} body
 * @param {Object} opts
 */
export function menuList(body, opts) {
    return $POST('/api/v1/menu/list', body, opts)
}


/**
 *
 * @param {*} vue
 * @param {*} opts
 */
export function walletSendCoupon(body, opts) {
    return $POST('/api/v1/wallet/sendCoupon', body, opts)
}

/**
 * @desc 万达钱包初审额度获取接口
 * @param {String} body {mobile,scenario:pre_register,captcha:图形验证码}
 * @param {Object} opts 参数
 * @returns {Promise}
 */
export function getSimpleCreditApply(body, opts) {
    return $POST('/api/v1/simpleCreditApply', body, opts)
}

/**
 * @desc 营销页手机号记录
 * @param {{ mobile: string, scene: string }} body
 * @param {*} opts
 */
export function recordMarketingMobile(body, opts) {
    return $POST('/api/v1/marketing/mobile/records', body, opts)
}

/**
 * @desc 微信 JSSDK 签名
 * @param {String} pageUrl - 当前页面 URL（不含 hash）
 * @param {Object} opts
 * @returns {Promise}
 */
export function wxSignature(pageUrl, opts) {
    const url = `/api/v1/publicNo/auth/jsSignature`
    return $GET(url, { pageUrl }, opts)
}



// WEBPACK FOOTER //
// ./src/utils/services/index.js